import React, { Suspense } from 'react';
import FutureSchool from './components/futureSchool/futureSchool';
import VoiceAssistant from './components/voiceAssistant/voiceAssistant';
import Footer from './components/footer/footer';
import { 
  CssBaseline, 
  Box, 
  Container, 
  Typography
} from '@mui/material';

// Lazy load components for better performance
const Chatbot = React.lazy(() => import('./components/Chatbot/Chatbot'));
const ThemeToggle = React.lazy(() => import('./components/ThemeToggle/ThemeToggle'));


function App() {
  return (
    <>
      <CssBaseline />
            <Box
              sx={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                bgcolor: 'background.default',
                color: 'text.primary',
                transition: 'all 0.3s ease',
              }}
            >
              <Container maxWidth="lg" sx={{ py: 4, flex: 1 }}>
                <Typography 
  variant="h6" 
  align="center" 
  sx={{ 
    mb: 1,
    color: theme => theme.palette.mode === 'dark' ? '#90caf9' : '#1a365d',
    fontWeight: 500,
    letterSpacing: '1px'
  }}
>
  Science Expo 2025
</Typography>
                <Typography 
                  variant="h2" 
                  component="h1" 
                  gutterBottom 
                  align="center" 
                  sx={({ palette }) => ({
                    mb: 4,
                    fontWeight: 800,
                    fontSize: { xs: '2.2rem', sm: '3rem', md: '3.5rem' },
                    background: palette.mode === 'dark' 
                      ? 'linear-gradient(45deg, #90caf9 0%, #64b5f6 50%, #42a5f5 100%)' 
                      : 'linear-gradient(45deg, #1a365d 0%, #2c5282 50%, #4299e1 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    textShadow: '2px 2px 4px rgba(0,0,0,0.1)',
                    letterSpacing: '0.5px',
                    lineHeight: 1.2,
                    position: 'relative',
                    display: 'inline-block'
                  })}
                >
                  
                  🎓 Bishop Corrie NextGen Learning Experience
                </Typography>
                <Typography variant="h5" align="center" color="textSecondary" paragraph>
                  Transforming Education with AI-Powered Learning Solutions
                </Typography>
                
                <Box sx={{ mt: 6, textAlign: 'center' }}>
                  <Typography variant="h4" gutterBottom>
                    Discover the Future of Education
                  </Typography>
                  <Box sx={{ maxWidth: '800px', mx: 'auto', textAlign: 'left', pl: { xs: 2, sm: 4 } }}>
                    <Typography variant="body1" paragraph>
                      <Box component="span" sx={{ fontWeight: 'bold', color: 'primary.main' }}>🤖 AI Chatbot:</Box> Get instant information about school history, sports, and timings.
                    </Typography>
                    <Typography variant="body1" paragraph>
                      <Box component="span" sx={{ fontWeight: 'bold', color: 'secondary.main' }}>🎤 Voice Assistant:</Box> Find out the class Teacher's name of all the classes
                    </Typography>
                    <Typography variant="body1" paragraph>
                      <Box component="span" sx={{ fontWeight: 'bold', color: 'success.main' }}>✨ Future-Ready:</Box> Experience how we're transforming education with cutting-edge technology.
                    </Typography>
                    <Typography variant="body1" sx={{ fontStyle: 'italic', mt: 2, textAlign: 'center' }}>
                      Try them out using the icons in the bottom right corner!
                  </Typography>
                  </Box>
                </Box>
              </Container>
              
              {/* Add FutureSchool component here */}
              <FutureSchool />
              <VoiceAssistant />
              <Footer />



              <Suspense fallback={<div>Loading...</div>}>
                <Chatbot />
                <ThemeToggle />
              </Suspense>
            </Box>
    </>
  );
}

export default App;